import React from 'react';

import NavItem from '@components/Nav/TopNav/NavItem';
import NavItemList from '@components/Nav/TopNav/NavItemList';
import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, TrackingLocation, click } from '@tracking';

interface EventNavigationProps {
  hasAgenda: boolean;
  hasPartners: boolean;
  hasSpeakers: boolean;
}

function EventNavigation({ hasSpeakers, hasAgenda, hasPartners }: EventNavigationProps) {
  const { trackEvent } = useEventTracking({
    location: TrackingLocation.EventsShowPage,
  });

  const navItems = [
    { id: 'speakers', label: 'Speakers', visible: hasSpeakers },
    { id: 'agenda', label: 'Agenda', visible: hasAgenda },
    { id: 'partners', label: 'Partners', visible: hasPartners },
  ].filter((item) => item.visible);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    trackEvent(
      click({
        clickTarget: ClickTarget.EventShowPageNavigation,
        clickText: e.currentTarget.textContent,
      })
    );
    const target = document.getElementById(e.currentTarget.getAttribute('href')?.substring(1));
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    window.history.pushState(null, '', e.currentTarget.getAttribute('href'));
  };

  if (navItems.length === 0) return null;

  return (
    <NavItemList className="mt-28 flex items-center gap-24 border-0 border-b border-solid border-primary-black md:mt-0">
      {navItems.map((item, index) => (
        <NavItem
          className="!px-6"
          key={item.id}
          as="link"
          href={`#${item.id}`}
          showLeftDivider={index > 0}
          onClick={handleClick}
        >
          {item.label}
        </NavItem>
      ))}
    </NavItemList>
  );
}

export default EventNavigation;
